import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/(private)/organizations')({
	component: () => <Outlet />,
	staticData: {
		breadcrumb: 'operator-organizations:page_title'
	}
})
